(function($) {
	Drupal.behaviors.dataMSG = {
		attach: function(context, settings) {
			$('[js-data-msg-required]').each(function() {
				let context = $(this);
				context.attr('data-msg-required', context.attr('js-data-msg-required'));
			});

			$('[js-data-msg-maxlength').each(function() {
				let context = $(this);
				context.attr('data-msg-maxlength', context.attr('js-data-msg-maxlength'));
			});
		}
	}
})(jQuery);